import { Injectable } from '@angular/core';
import { FeatureGuard } from '@app/shared/guards/feature-guard.service';
import { SessionCookieService } from '@app/core/cookies';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class GetPaidGuard extends FeatureGuard {
  featureName = 'hyperwallet';

  constructor(protected sessionService: SessionCookieService, protected router: Router, protected dialog: MatDialog) {
    super(sessionService, router, dialog);
  }
}
